import { useTheme } from "../hooks/use-theme";
import React, { useMemo } from "react";
import { StyleSheet, View, Text } from "react-native";
import { CalloutMode } from "../ui_atoms/Callout";

export type ScreenCardHeadbandProps = {
    text: string | Array<string>;
    mode?: CalloutMode;
};

const ScreenCardHeadband: React.FC<ScreenCardHeadbandProps> = ({ text, mode }) => {
    const { colors } = useTheme();
    const styles = useStylesheet();

    const background = useMemo(() => {
        switch (mode) {
            case "warning":
                return colors.warningBackground;
            case "error":
                return colors.errorBackground;
            case "info":
                return colors.infoBackground;
            case "success":
                return colors.successBackground;
            default:
                return colors.infoBackground;
        }
    }, [colors, mode]);

    const onBackground = useMemo(() => {
        switch (mode) {
            case "warning":
                return colors.onWarningBackground;
            case "error":
                return colors.onErrorBackground;
            case "info":
                return colors.onInfoBackground;
            case "success":
                return colors.onSuccessBackground;
            default:
                return colors.onInfoBackground;
        }
    }, [colors, mode]);

    const allTexts = Array.isArray(text) ? text : [text];

    return (
        <View style={[styles.container, { backgroundColor: background }]}>
            {allTexts.map((t, i) => (
                <View key={i} style={{ flex: 1 }}>
                    <Text style={[styles.cell, { color: onBackground }]}>{t}</Text>
                </View>
            ))}
        </View>
    );
};

const useStylesheet = () => {
    const theme = useTheme();
    return useMemo(() => {
        return StyleSheet.create({
            container: {
                alignSelf: "stretch",
                padding: theme.gridSize / 2,
                flexDirection: "column",
                alignItems: "center",
                marginBottom: theme.gridSize / 2,
            },
            cell: {
                flex: 1,
                flexGrow: 1,
                textAlign: "center",
            },
        });
    }, [theme]);
};

export const buildErrorHeadband = (text: string | Array<string>): ScreenCardHeadbandProps => {
    return { mode: "error", text: text };
};

export default ScreenCardHeadband;
